export const keyExtractor = (bankAccount) => bankAccount.id.toString();
